var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.json),function(lastMarks){return _c('div',{key:lastMarks._ID,staticClass:"lastMarks whitebg shadow d-inline-block"},[_vm._v("      \n    "+_vm._s(lastMarks.Texte)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }